<script type="text/jsx" lang="jsx">
import _ from 'lodash';
import { toThousands } from '@/utils/money';
import { planTypes, isEventSaasOrEventSassCore } from '@/common/constants';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  name: 'config-consumption-row',
  props: {
    selectCapacitySize: {
      type: String,
      default: 'large',
    },
    capacityKey: {
      type: String,
      default: 'capacity',
    },
    planType: {
      type: String,
      default: planTypes.EVENT_SAAS,
    },
  },
  data() {
    return {
      trackingPlanKey: '',
    };
  },
  computed: {
    ...mapGetters(['getTypeGroupSelectedPlans', 'planMapFlat']),
    capacityList() {
      const consumptionPlanList = _.filter(this.planMapFlat, (p) => p.type === this.planType && p.isPPA);

      return _.chain(consumptionPlanList)
        .uniq(this.capacityKey)
        .orderBy(this.capacityKey)
        .value();
    },
    selectedPlanList() {
      return _.filter(this.getTypeGroupSelectedPlans[this.planType], (p) => p.isPPA);
    },
    selectedPlan() {
      return _.get(this.selectedPlanList, [0], {});
    },
    selectCapacity() {
      return this.selectedPlan?.capacity;
    },
  },
  methods: {
    ...mapMutations(['batchRemovePlan', 'updateSelectPlan']),
    ...mapActions(['switchCapacityAction']),
    mx_renderTitle() {
      return <h2 class="opc-consumption-config__title">Select number of {isEventSaasOrEventSassCore(this.planType) ? 'attendees' : 'participants'}</h2>;
    },
    mx_renderCapacityDropDown() {
      return <div class="opc-consumption-config__capacity--dropdown">
        <zm-select
          data-testid="checkout-select-50"
          ref="attendeeSelect"
          popperAppendToBody={true}
          size={this.selectCapacitySize}
          modelValue={this.selectCapacity}
          aria-label="zoom sessions Select number of attendees"
          onChange={this.onSwitchCapacity}
          class="opc-consumption-config__capacity--select">
          {this.capacityList.map((p) => {
            return <zm-select-option
              data-testid="checkout-option-51"
              key={p.capacity}
              value={p.capacity}
              label={toThousands(p.capacity)}
            />;
          })}
        </zm-select>
        {
          this.$slots.attendee ??
            <div>
              <span class="opc-consumption-config__capacity--unit">
                {
                  isEventSaasOrEventSassCore(this.planType) ?
                    this.$t('billing.events.attendees', ['']) :
                    this.$t('billing.participants')
                }
              </span>
            </div>
        }
      </div>;
    },
    mx_renderCapacityDesc() {
      return <div class="opc-consumption-config__capacity--desc">
        <span class="opc-consumption-config__capacity--desc-price">{this.$money(this.selectedPlan?.amount, {forceDiff:true})}</span>
        <span
          class="opc-consumption-config__capacity--desc-unit">
          ({this.selectCapacity} {isEventSaasOrEventSassCore(this.planType) ? this.$t('billing.common.per_billing_cycle_attendee.annual') : this.$t('billing.common.per_billing_cycle_attendee.annual').replace('attendees', 'participants')}<priceVATTip />)
        </span>
        <zm-tooltip
                class="opc-consumption-config__capacity--tooltips"
                disallowLearnAbout
                aria-label="Learn more about Select the number of capacity"
                content={this.$t('billing.events.ppa.attendeeTips')}
                placement="bottom"
                onInput={this.toggleCapacityTips}>
                <tips-icon type="info" aria-label="Learn more about Select the number of capacity" />
        </zm-tooltip>
      </div>;
    },
    mx_renderCapacityRow() {
      return <div class="opc-consumption-config__capacity--row">
        {this.mx_renderCapacityDropDown()}
        {this.mx_renderCapacityDesc()}
      </div>;
    },
    onSwitchCapacity(capacity) {
      const nextPlan = _.find(this.capacityList, (p) => p.capacity === capacity);
      this.switchCapacityAction([this.selectedPlan?.plan_code, { ...nextPlan, cartInfo: { selected_number: 1 } }]);
      if (this.$context.is.zs2ze) {
        this.$tracking.buyInteraction(`zoom events pay per attendee attendees`, `pay per attendee - ${capacity} attendees/year`);
      }
    },
    toggleCapacityTips(tips) {
      if (this.$context?.is.zs2ze) {
        tips && this.$tracking.buyInteraction(`zoom events options`, 'select number of attendees - tooltip');
      }
    },
    addDefaultPlan() {
      const plan = _.get(this.capacityList, [0], {});

      this.updateSelectPlan({
        plan_code: plan.plan_code,
        cartInfo: { selected_number: 1 },
      });
    },
    removePlans() {
      return this.batchRemovePlan(this.selectedPlanList);
    },
  },
  render() {
    return <div class="opc-consumption-config">
      {this.mx_renderTitle()}
      {this.mx_renderCapacityRow()}
    </div>;
  },
};
</script>

<style lang="scss">
@import './config-consumption-row.scss';
</style>
<style scoped lang="scss">
:deep(.opc-btn-icon__wrapper) {
  transform: translateY(-5px);
}
</style>
